import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPROMOSELECTPRODUCTPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image",
  "text_color",
  "link_url"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskPromoSelectProductPageDescriptor: _generatedKioskPromoSelectProductPageDescriptor,
  kioskPromoSelectProductPageBlocDefinition,
  kioskPromoSelectProductPageDashboardLayout,
  kioskPromoSelectProductPageConfig,
  kioskPromoSelectProductPageResolveConfig,
  kioskPromoSelectProductPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Loyalty product picker page",
    internal_name: "Kiosk - Loyalty product picker page",
    url: "promo-select",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskPromoSelectProductPageComponent',
    category: 'page',
    description: "Kiosk - Loyalty product picker page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-promo-select-product-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskHeaderBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'body',
        name: "pages.blocks.kiosk-promo-select-product-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskPromoSelectProductBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.kiosk-promo-select-product-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskFooterCartBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-promo-select-product-page.background-image.label",
        help: "pages.blocks.kiosk-promo-select-product-page.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product-page.text-color.label",
      }
    }),
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.kiosk-promo-select-product-page.link-url.label",
        help: "pages.blocks.kiosk-promo-select-product-page.link-url.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-promo-select-product-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-promo-select-product-page.fieldset.navigation.label",
            fields: ["link_url"],
          },
          {
            legend: "pages.blocks.kiosk-promo-select-product-page.fieldset.appearance.label",
            fields: ["background_color", "background_image", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-promo-select-product-page.fieldset.blocks.label",
            fields: ["header", "body", "footer"],
          },
        ],
      },
    ],
  })
);

export function kioskPromoSelectProductPageDescriptor(): IBlockDescriptor;
export function kioskPromoSelectProductPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskPromoSelectProductPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskPromoSelectProductPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskPromoSelectProductPageDescriptor, kioskPromoSelectProductPageProperties, fieldOrder);
}

export {
  kioskPromoSelectProductPageBlocDefinition,
  kioskPromoSelectProductPageDashboardLayout,
  kioskPromoSelectProductPageProperties,
  kioskPromoSelectProductPageConfig,
  kioskPromoSelectProductPageResolveConfig,
};

export type KioskPromoSelectProductPageConfig = typeof kioskPromoSelectProductPageConfig;
